'use client';
import { createContext, useContext } from "react";

const ProductContext = createContext(null);

export function ProductProvider({ value, children }) {
    return (
        <ProductContext.Provider value={value}>
            {children}
        </ProductContext.Provider>
    );
}

export function useProduct() {
    const ctx = useContext(ProductContext);
    if (!ctx) throw new Error('useProduct must be used within a ProductProvider');
    return ctx;
}